import { bool, func, object } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../generic/Tooltip/get-info-tooltip';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import HELP_TEXTS from '../help-texts';

function ExportAllOpportunities({
  onRequest,
  loading,
  exportParams,
  tableFilters,
  ...rest
}) {
  return (
    <Button
      disabled={loading}
      onClick={() =>
        onRequest({ search: { ...exportParams, ...tableFilters } })
      }
      {...rest}
    >
      Export{' '}
      {getInfoTooltip(
        HELP_TEXTS,
        'exportOpportunities',
        'actionButtons',
        'top',
      )}
    </Button>
  );
}

ExportAllOpportunities.propTypes = {
  onRequest: func.isRequired,
  loading: bool.isRequired,
  exportParams: object.isRequired, // eslint-disable-line react/forbid-prop-types,
  tableFilters: object, // eslint-disable-line react/forbid-prop-types,
};

ExportAllOpportunities.defaultProps = {
  tableFilters: {},
};

export default withApiRequest({
  query: api.exportOpportunities,
  error: 'flash',
  successMessage: 'Email with all opportunities is being prepared',
})(ExportAllOpportunities);
